// @ts-nocheck

/**
 * get3PointsBezierCurve
 *
 * Returns a function that computes one of the coordinates (x U y) of the point at time t
 * on the bezier curve which is defined by 3 given points:
 * - A (starting point)
 * - B ("middle" point, responsible of the angle)
 * - C (ending point)
 *
 * For t being the completeness ratio of the animation and 0 <= t <= 1
 */
export const get3PointsBezierCurve = (A: number, B: number, C: number) => (t: number) =>
  Math.pow(1 - t, 2) * A + 2 * (1 - t) * t * B + Math.pow(t, 2) * C;
